import { SettingApi } from "lib/api";
import { ApiHelper, Http } from "lib/api/base";

import { notification } from "antd";

import { User } from "lib/data/model";
import { ValidationError } from "lib/data/transfer/ValidationError";
import { SerializableError } from "lib/data/types";

export class UserApi {

	/**
	 * If the specified user has a user id, update the record. Else create a new user record
	 */
	public static updateCreateUser = async (userRecord: User): Promise<User | ValidationError | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/User`;

			let response: Response;

			// Make Request
			if (userRecord.id !== undefined) {

				// Make Request (Append URL)
				response = await Http.httpPut(`${url}/${userRecord.id}`, userRecord);
			}
			else {

				// Make Request
				response = await Http.httpPost(url, userRecord);
			}

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const user: User = await ApiHelper.parseResponseBody(response);

				return user;
			}
			else {

				switch (response.status) {

					case 422: // Unprocessable Entity

						const userCreationErrors: SerializableError = await ApiHelper.parseResponseBody(response);

						return new ValidationError(userCreationErrors);

					default:

						notification.error({
							message: "Error Saving User"
						});

						break;
				}
			}
		}

		// Return Nothing
		return undefined;
	}

	public static deleteUser = async (userId: number): Promise<boolean> => {
		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/User/${userId}`;

			// Make Request
			const response: Response = await Http.httpDelete(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const requirement: boolean = await ApiHelper.parseResponseBody(response);

				return requirement;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return false;
	}

	public static getAllUsers = async (): Promise<User[]> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/User`;

			// Make Request
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const requirement: User[] = await ApiHelper.parseResponseBody(response);

				return requirement;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return [];
	}
}
